import { useEffect, useState } from 'react';
import { Pager as PagerComponent } from '@coveo/headless';
import Pager from './LMPager';

interface ICoveoPagerProps {
  pager: React.MutableRefObject<PagerComponent>;
}
export default function CoveoPager({ pager }: ICoveoPagerProps) {
  const [pagerState, setPagerState] = useState(pager.current.state);
  useEffect(() => {
    const unsub = pager.current.subscribe(() => setPagerState(pager.current.state));
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function setPage(pageNumber: number) {
    pager.current.selectPage(pageNumber);
    window.scrollTo(0, 0);
  }
  return (
    <>
      {pagerState.maxPage !== 0 && (
        <Pager
          currentPage={pagerState.currentPage}
          count={pagerState.maxPage}
          onChange={(page: number) => setPage(page)}
          maxShown={5}
        />
      )}
    </>
  );
}
